<template>
  <el-table-column :label="label" :prop="prop" class-name="status-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'ステータス'
    },
    prop: {
      type: String,
      default: 'status_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.status-code {
      width: 15em;
    }
  }
}
</style>
